import { Component, Input } from '@angular/core';
import { DetailChange, EHistory, MergeAsCqAndNewInqData } from './enchanted-history';
import { InteractionsService } from 'app/modules/data-model/interaction/interactions.service';
import { EmailMessageComponent } from 'app/modules/administration/mailbox/email-polling/email-message/email-message.component';
import { GenericDialogService } from 'app/common/common/generic-dialog/generic-dialog.service';
import { MessageHandlerService } from 'app/common/common/message-handler/message-handler.service';
import { NgbdModalUser } from 'app/common/common/modal/modal-user/modal-user.component';
import { localUrl } from 'app/common/url-resolver.service';

@Component({
  selector: 'app-detail-history-change',
  templateUrl: './detail-history-change.component.html',
  styleUrl: './detail-history-change.component.scss',
})
export class DetailHistoryChangeComponent {
  @Input() history: EHistory;
  @Input() data: DetailChange;
  @Input() loggedInUserIsSysAdmin: boolean = false;

  readonly freeTextRawFields = [
    'question',
    'answer',
    'answer_draft',
    'greetings',
    'signature',
    'disclaimer',
    'gdpr_notification',
  ];
  readonly discRawFields = [
    'disclaimer_info',
    'reason_for_replacement',
    'reason_for_removal',
    'reason_for_removal_from_interaction',
    'reason_for_inclusion',
    'reason_for_inclusion_from_interaction',
    'reason_for_disc_update',
  ];
  readonly splitTextRawFields = ['text_before_split', 'text_after_split', 'text_to_split'];
  readonly referencesRawFields = [
    'reference_question_id',
    'reference_source',
    'reference_id',
    'reference_type',
  ];
  readonly historySkipRawFields = [
    'inquirer',
    'inquirer_details',
    'team_update_details',
    'assignment_removal_on_team_update_details',
    'assignment_removal_on_role_archive_details',
    'merge_as_inquiry',
    'merge_as_new_inquiry',
    'question_id',
    'question_ids',
    'disclaimer_info',
    'reason_for_replacement',
    'reason_for_removal',
    'reason_for_removal_from_interaction',
    'reason_for_inclusion',
    'reason_for_inclusion_from_interaction',
    'reason_for_disc_update',
    'reason_for_update',
    'reason_for_update_accessory',
    'due_date',
    'inserted_from_draft',
    'notification',
    ...this.splitTextRawFields,
    ...this.referencesRawFields,
  ];
  readonly jsonSemiDetailChangeCategories = [
    'forward_to_dept',
    'forward_to_user',
    'update_watchers',
  ];

  constructor(
    private interactionsService: InteractionsService,
    private messageService: MessageHandlerService,
    private dialogService: GenericDialogService
  ) {}

  // Cast can be replaced with satisfies after angular upgrade.
  getFromData(data: DetailChange): MergeAsCqAndNewInqData[] {
    return data.from as MergeAsCqAndNewInqData[];
  }

  emailMessagePreview(historyId: string, messageId: number): void {
    this.interactionsService.getHistoryMessage(historyId, messageId).subscribe({
      next: (message) => {
        const ref = this.dialogService.open(EmailMessageComponent, { autoFocus: 'dialog' });
        ref.componentInstance.message = message;
        ref.componentInstance.canOpenFile = true;
        ref.componentInstance.canViewFullMessageData = false;
      },
      error: (error) =>
        this.messageService.httpError('An error occurred while fetching the message', error),
    });
  }

  previewUser(userId: number): void {
    this.dialogService.open(NgbdModalUser, { data: { userId: userId } });
  }

  previewInquirer(inquirerId: number): void {
    this.dialogService.open(NgbdModalUser, { data: { inquirerId: inquirerId } });
  }

  resolveInteractionUrl(interactionId: number): string {
    return localUrl('detail', interactionId);
  }

  isObject(value: any): boolean {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }
}
